import { IconButton, Tooltip } from "@chakra-ui/react";
import { useEffect } from "react";

import { CodeSandboxIcon } from "@/integration/components/code-sandbox/CodeSandboxIcon";
import { useCodeSampleSandboxCreateMutation } from "@/integration/data/useCodeSampleSandboxCreateMutation";
import { CodeSampleSandboxTemplate } from "@reflag/shared/codeSampleSandboxAPI";

export function OpenInCodeSampleSandboxButton({
  template,
  featureId,
}: {
  template: CodeSampleSandboxTemplate;
  featureId: string;
}) {
  const {
    mutate: createCodeSampleSandbox,
    isPending,
    data: response,
  } = useCodeSampleSandboxCreateMutation(featureId);

  useEffect(() => {
    if (response) {
      setTimeout(() => {
        window.open(response.url, "_blank");
      });
    }
  }, [response]);

  return (
    <Tooltip label={"Try in code sandbox"}>
      <IconButton
        aria-label="Try in code sandbox"
        icon={<CodeSandboxIcon />}
        isLoading={isPending}
        onClick={() => createCodeSampleSandbox({ template })}
      />
    </Tooltip>
  );
}
